import { LOCAL_MCP_USER_PREFIX, LOCAL_MCP_PROJECT_PREFIX } from '@/component/mcpCatalog/McpCatalogConstant';

// supportedOS is stored as a list of strings (e.g. ["Windows", "Mac"]).
// Normalize any incoming value into a clean string array for the form.
// A legacy comma-separated string is also tolerated for backward compatibility.
export const parseSupportedOS = value => {
    let list = value;
    if (typeof list === 'string') {
        list = list.split(',');
    }
    if (!Array.isArray(list)) {
        return [];
    }
    return list.map(os => String(os).trim()).filter(os => os !== '');
};

/**
 * Append scope prefix suffix to a catalog ID to distinguish user vs project local MCP.
 * Example: appendLocalMcpScope('cat123', LOCAL_MCP_PROJECT_PREFIX) → 'cat123:[P]'
 *          appendLocalMcpScope('cat123', LOCAL_MCP_USER_PREFIX)    → 'cat123:[U]'
 *
 * @param {string} catId - raw catalog ID
 * @param {string} prefix - LOCAL_MCP_PROJECT_PREFIX or LOCAL_MCP_USER_PREFIX
 * @returns {string} catalog ID with scope suffix
 */
export const appendLocalMcpScope = (catId, prefix) => {
    return `${catId}:${prefix}`;
};

/**
 * Parse a scoped catalog ID back into the raw catalog ID and prefix.
 * Example: parseLocalMcpScope('cat123:[P]') → { catId: 'cat123', prefix: '[P]' }
 *          parseLocalMcpScope('cat123:[U]') → { catId: 'cat123', prefix: '[U]' }
 *          parseLocalMcpScope('cat123')     → { catId: 'cat123', prefix: '[U]' }
 *
 * @param {string} scopedId - catalog ID potentially containing scope suffix
 * @returns {{ catId: string, prefix: string }}
 */
export const parseLocalMcpScope = (scopedId) => {
    if (!scopedId || typeof scopedId !== 'string') {
        return { catId: scopedId, prefix: LOCAL_MCP_USER_PREFIX };
    }
    const projectSuffix = `:${LOCAL_MCP_PROJECT_PREFIX}`;
    const userSuffix = `:${LOCAL_MCP_USER_PREFIX}`;

    if (scopedId.endsWith(projectSuffix)) {
        const catId = scopedId.slice(0, -projectSuffix.length);
        return { catId, prefix: LOCAL_MCP_PROJECT_PREFIX };
    }
    if (scopedId.endsWith(userSuffix)) {
        const catId = scopedId.slice(0, -userSuffix.length);
        return { catId, prefix: LOCAL_MCP_USER_PREFIX };
    }
    return { catId: scopedId, prefix: LOCAL_MCP_USER_PREFIX };
};

const McpUtils = {
    parseSupportedOS,
    appendLocalMcpScope,
    parseLocalMcpScope
};
export default McpUtils;
